import connect from 'utils/store/connect';

import Notifications from './components/Notifications';
import dateSelector from './selectors/date';
import messageSelector from './selectors/message';
import classificationSelector from './selectors/classification';

/**
 * Return object mapping state to prop
 * @param {object} state - Redux state object
 * @returns {object} Object for react props
 */
const mapStateToProps = state => ({
  classification: classificationSelector(state),
  date: dateSelector(state),
  message: messageSelector(state)
});

export default connect(mapStateToProps)(Notifications);
